var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("کاربر")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/user/list"}},[_vm._v("لیست کاربران")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }